import React from 'react';
export function Footer() {
  return <footer className="bg-black py-8 px-4 text-center border-t border-white/10" data-id="element-106">
      <div className="max-w-4xl mx-auto" data-id="element-107">
        <p className="text-gray-500 text-sm mb-4" data-id="element-108">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <p className="text-gray-400 font-bold" data-id="element-109">
          © {new Date().getFullYear()} Megapack Padel Resuelto. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}